export class Constants {
    static readonly DR_NAMES:any = [
        {"Name":"Dr.NGANGASE KASONGO","DrHospitalName":"assets/images/DrHospitalName1.png","SignatureIMG":"assets/images/SignatureIMG1.png","DrStamp":"assets/images/DrStamp1.png"},
        {"Name":"Dr.KAPANGALA WUMA Michel","DrHospitalName":"assets/images/DrHospitalName2.png","SignatureIMG":"assets/images/SignatureIMG2.png","DrStamp":"assets/images/DrStamp2.png"},
        {"Name":"Dr.JEAN PIERRE MAKANDA ESOWA","DrHospitalName":"assets/images/DrHospitalName3.png","SignatureIMG":"assets/images/SignatureIMG3.png","DrStamp":"assets/images/DrStamp3.png"},
    ];
    
  }